import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./logindesign.css";
import { useAuth } from './AuthContext';
import App from './App';
import LoginFailedModal from "./LoginFailedModal";
import { postLogin } from './apiService';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";

const LoginForm = () => {
  const history = useHistory();
  const { isAuthenticated, login } = useAuth();
  const [companyCode, setCompanyCode] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginFailed, setLoginFailed] = useState(false);
  const [companyCodeValidated, setCompanyCodeValidated] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);

  const handleCompanyValidation = async () => {
    try {
      // Implement company code validation logic here
      // For demonstration purposes, assume the company code is valid if it's not empty
      if (!companyCode.trim()) {
        //throw new Error('Company code is required.');
        toast.error('Company code is required.', {
          position: toast.POSITION.TOP_CENTER,
        });

      }

      if (companyCode.trim()) {

        const CompanyData = {
          CompanyCode: companyCode,
        };


        const response = await postLogin('CompanyLoginApi', CompanyData);

        if (response.responseCode === '1111') {
          setCompanyCodeValidated(true);
          setCompanyId(response.response_data.id)
          setCompanyName(response.response_data.name);
          setLoginFailed(false); // Reset loginFailed state
        } else {
          throw new Error(response.Message);
        }
      }

    } catch (error) {
      // toast.error("Company login failed", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      toast.error('Login failed', {
        position: 'top-center',
      });
    }
  };

  const handleLogin = async () => {
    try {

      if (!companyCodeValidated) {
        throw new Error('Company code validation is required.');
      }

      const jwtToken = await performLogin();
      const responseData = jwtDecode(jwtToken);
      const keysToRemove = ['iss', 'exp', 'ttp', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name', 'aud'];
      const permissions = Object.keys(responseData).filter(
        (key) => key !== 'companyId' && key !== 'userId' && !keysToRemove.includes(key)
      );

      let isSuper = false;
      if (responseData.isSuperAdmin.toLowerCase() === "true") {
        isSuper = true;
      }

      login(responseData.companyId, responseData.userId, isSuper, responseData.superAdminCompanyId, companyName, permissions, jwtToken, responseData.roleName, responseData.username);


      const redirectParam = new URLSearchParams(location.search).get('redirect');
      const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : '/Home';


      // Redirect the user to the original location or the default "/Home"
      history.replace(redirectPath);
    } catch (error) {
      // toast.error('Login failed', {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      toast.error('Login failed', {
        position: 'top-center',
      });
    }
  };


  const performLogin = async () => {
    const loginData = {
      UserName: username,
      Password: password,
      CompanyId: companyId
    };

    const response = await postLogin('LoginApi', loginData);

    if (response.responseCode === '1111') {
      const jwtToken = response.response_data.token;

      return jwtToken;
    } else {
      throw new Error(response.Message);
    }
  };

  const closeModal = () => {
    setLoginFailed(false);
  };

  if (isAuthenticated) {
    return <App />;
  }

  return (
    <div className="containers"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#0d2545",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
      }}>
      <ToastContainer />
      <div className="login-boxs"
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "30px",
          borderRadius: "12px",
          background: "#1c3b6e",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.5)",
          textAlign: "center",
        }}
      >
        {/* <br /> */}
        <h4 style={{ marginBottom: "20px", color: "#fff", fontFamily: "cursive" }}>LOGIN</h4>
        {/* <br /> */}

        {!companyCodeValidated && (
          <form onSubmit={(e) => {
            e.preventDefault();
            handleCompanyValidation();
          }}>
            <div className="cc">
              <label style={{color:'white'}}>COMPANY CODE</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                type="text"
                placeholder="Enter company code"
                value={companyCode}
                onChange={(e) => setCompanyCode(e.target.value)}
              />
            </div>
            <br />
            <button
              type="submit"
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "15px",
                borderRadius: "8px",
                border: "1px solid #fff",
                background: "transparent",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "#fff";
                e.target.style.color = "#000";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.color = "#fff";
              }}
            >
              Let Me In
            </button>
            {/* <button className="lgn" type="submit">
              Let Me In
            </button> */}
          </form>
        )}

        {companyCodeValidated && (
          <div>
            <p className="welcome-message">Welcome to {companyName}</p>
            <br />
            {/* <form onSubmit={(e) => {
              e.preventDefault();
              handleLogin();
            }}>
              <div className="em">
                <label>USERNAME</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  type="text"
                  placeholder="Enter username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>

              <div className="pwd">
                <label>PASSWORD</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button className="lgn" type="submit">Login</button>
            </form> */}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleLogin();
              }}
            >
              {/* Username field with icon */}
              <div style={{ position: "relative", marginBottom: "15px" }}>
                <FaUser
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    color: "#ccc",
                  }}
                />
                <input
                  type="text"
                  placeholder="User Name"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 10px 10px 40px",
                    borderRadius: "8px",
                    border: "1px solid #4c6793",
                    background: "#264a86",
                    color: "#fff",
                    outline: "none",
                  }}
                />
              </div>

              {/* Password field with icon and visibility toggle */}
              <div style={{ position: "relative", marginBottom: "15px" }}>
                <FaLock
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    color: "#ccc",
                  }}
                />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 10px 10px 40px",
                    borderRadius: "8px",
                    border: "1px solid #4c6793",
                    background: "#264a86",
                    color: "#fff",
                    outline: "none",
                  }}
                />
                <div
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    color: "#ccc",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </div>
              </div>

              <button
                type="submit"
                style={{
                  width: "100%",
                  padding: "10px",
                  marginTop: "15px",
                  borderRadius: "8px",
                  border: "1px solid #fff",
                  background: "transparent",
                  color: "#fff",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "#fff";
                  e.target.style.color = "#000";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "transparent";
                  e.target.style.color = "#fff";
                }}
              >
                Login
              </button>
            </form>
          </div>
        )}
      </div>

      {loginFailed && <LoginFailedModal onClose={closeModal} />}
    </div>
  );
};

export default LoginForm;
